export default __webpack_public_path__ + "static/media/network-security.c93fe46b.png";